import { Star } from 'lucide-react';

import { DEFAULT_MAX, STAR_SIZE_CLASS } from './RatingStars.constants';
import type { RatingStarsProps } from './RatingStars.types';

export const RatingStars = ({ value, max = DEFAULT_MAX, size = 'md', className = '' }: RatingStarsProps) => {
	const sizeClass = STAR_SIZE_CLASS[size];
	const stars = Array.from({ length: max }, (_, i) => ({ id: `star-${i}`, filled: i < value }));

	return (
		<span className={`inline-flex items-center gap-3xs ${className}`} aria-label={`${value} de ${max}`}>
			{stars.map((s) => (
				<Star
					key={s.id}
					className={`${sizeClass} ${s.filled ? 'fill-yellow-400 text-yellow-400' : 'text-grey-200'}`}
					strokeWidth={1.5}
				/>
			))}
		</span>
	);
};
